import React, { Profiler, useContext } from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { getHostCURL } from '../../common/utils/cardUtils';
import * as localData from '../../core/Constants';
import './SpendSummary.scss';
import { DataContext } from '../../contexts';
import * as CurrencyUtils from '../../common/utils/CurrencyUtils';

const ToolTipContent = React.forwardRef(() => {
  const termLink = getHostCURL('/c/ProXtra_TermsandConditions');
  return (
    <div className="LoyaltySummary__toolTipLabel">
      <p>{localData.spendToolTipLabel}</p>
      <p> {localData.spendToolTipLabel1}</p>
      <br />
      <p>{localData.spendToolTipLabel2}</p>
      <p>{localData.spendToolTipLabel3}</p>
      <br />
      <p>
        For full details, see the&nbsp;
        <a href={termLink} className="u__default-link" rel=" noreferrer">
          Pro Xtra Program Terms &amp; Conditions
        </a>
      </p>
    </div>
  );
});

const ToolTip = () => {
  return (
    <Profiler id="overview" onRender={() => {}}>
      <Tooltip channel="desktop" content={<ToolTipContent />} interactive>
        <span><Image
          className="LoyaltySummary__infoLogo"
          src="https://assets.thdstatic.com/images/v1/info-white.svg"
          alt="info-white"
        />
        </span>
      </Tooltip>
    </Profiler>
  );
};

export const SpendSummary = () => {
  const { userData } = useContext(DataContext);
  const proXtraSpend = userData && userData?.proXtraSpend;
  const spendAmount = parseInt(proXtraSpend?.totalCurrentYearSpend || '0', 10);
  const savingsAmount = parseInt(proXtraSpend?.totalCurrentYearSavings || '0', 10);
  return (
    <div>
      <div className="col__8-12">
        <div className="LoyaltySummary__summaryLine">
          <div className="LoyaltySummary__spendAmount">
            <p className="LoyaltySummary__SingleFirstLine">
              ${CurrencyUtils.floorNumberWithCommas(spendAmount)}
            </p>
          </div>
          <div className="LoyaltySummary__spendLabel">Pro Xtra Spend
            <ToolTip />
          </div>
        </div>
      </div>
      <div className="col__4-12">
        <div className="LoyaltySummary__summarySaving">
          <div className="LoyaltySummary__savingAmount">
            ${CurrencyUtils.floorNumberWithCommas(savingsAmount)}
          </div>
          <div className="LoyaltySummary__spendLabel">Savings</div>
        </div>
      </div>
    </div>
  );
};
